// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dsjM","inner":"Footer_inner__QtTSF"};